import React, { useState,useEffect } from 'react';
import { Card,Row,Col,Placeholder } from 'react-bootstrap';
const DepartmentProjects = ({ pageData }) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isOngoing, setOngoing] = useState(true);
    const[isCompleted, setCompleted] = useState(true);
    const[Ongoings,setOngoings]=useState([]);
    const[Completes,setCompletes]=useState([]);
    useEffect(()=>
    {
        const OngoingProjectsByDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departmentProjects/ongoingByDepartment/"+pageData.sp_sd_id);
                const result = await response.json();
                setOngoings(result);
                setOngoing(false);
                if( global.config.IsPrint === true ) { console.info('OngoingProjectsByDepartment : Result',result); }
            } catch (error) 
            {
                console.error('OngoingProjectsByDepartment : Error', error.message);
                setOngoing(false);
            }
        };
        const CompletedProjectsByDepartment = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departmentProjects/completedByDepartment/"+pageData.sp_sd_id);
                const result = await response.json();
                setCompletes(result);
                setCompleted(false);
                if( global.config.IsPrint === true ) { console.info('CompletedProjectsByDepartment : Result',result); }
            } catch (error) 
            {
                console.error('CompletedProjectsByDepartment : Error', error.message);
                setCompleted(false);
            }
        };
        CompletedProjectsByDepartment();
        OngoingProjectsByDepartment();
    },[pageData])
    return (
        <Card className='mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 'बाह्य वित्त पोषित अनुसंधान परियोजनाएँ' : 'EXTERNALLY FUNDED RESEARCH PROJECTS'}
            </Card.Header>
            <Card.Body>
            {isCompleted ? (
                <Card className='border-primary bg-success bg-opacity-75 mb-4'>
                    <Card.Header className='text-bg-primary text-center text-uppercase'><Placeholder xs={6} /></Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                        {[...Array(6)].map((_,index)=>(
                            <Col md={4} key={index}>
                                <Card className='text-center shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                                    <Card.Header className='bg-success-subtle'>
                                        <div><Placeholder xs={10} /></div>
                                        <div><Placeholder xs={10} /></div>
                                    </Card.Header>
                                    <Card.Body>
                                        <Placeholder xs={10} />
                                        <Placeholder xs={12} />
                                        <Placeholder xs={8} />
                                        <Placeholder xs={6} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                        </Row>
                    </Card.Body>
                </Card>
                ) : (
                <Card className='border-primary bg-success bg-opacity-75 mb-4'>
                    <Card.Header className='text-bg-primary text-center text-uppercase fs-4'>
                        {appLanguage === 'hi' ? 'पूर्ण' : 'COMPLETED'}
                    </Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                        {Completes.map((dp,index)=>(
                            <Col md={4} key={index}>
                                <Card className='text-center shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                                    <Card.Header className='bg-success-subtle text-dark'>
                                        <div>{appLanguage === 'hi' ? 'मुख्य जाँचकर्ता:' : 'Principal Investigator:'}</div>
                                        <div>{appLanguage === 'hi' ? dp.users.su_name_hi || dp.users.su_name : dp.users.su_name}</div>
                                    </Card.Header>
                                    <Card.Body className='d-flex align-items-center justify-content-center' dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? dp.dp_details_hi || dp.dp_details : dp.dp_details}}></Card.Body>
                                </Card>
                            </Col>
                        ))}
                        </Row>
                    </Card.Body>
                </Card>
            )}
            {isOngoing ? (
                <Card className='border-primary bg-success bg-opacity-75 mb-4'>
                    <Card.Header className='text-bg-primary text-center text-uppercase'><Placeholder xs={6} /></Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                        {[...Array(6)].map((_,index)=>(
                            <Col md={4} key={index}>
                                <Card className='text-center shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                                    <Card.Header className='bg-success-subtle'>
                                        <div><Placeholder xs={10} /></div>
                                        <div><Placeholder xs={10} /></div>
                                    </Card.Header>
                                    <Card.Body>
                                        <Placeholder xs={10} />
                                        <Placeholder xs={12} />
                                        <Placeholder xs={8} />
                                        <Placeholder xs={6} />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                        </Row>
                    </Card.Body>
                </Card>
                ) : (
                <Card className='border-primary bg-success bg-opacity-75 mb-4'>
                    <Card.Header className='text-bg-primary text-center text-uppercase fs-4'>
                        {appLanguage === 'hi' ? 'चल रहे' : 'Ongoing'}
                    </Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                        {Ongoings.map((dp,index)=>(
                            <Col md={4} key={index}>
                                <Card className='text-center shadow h-100' data-aos="flip-up" data-aos-duration="1000">
                                    <Card.Header className='bg-success-subtle text-dark'>
                                        <div>{appLanguage === 'hi' ? 'मुख्य जाँचकर्ता:' : 'Principal Investigator:'}</div>
                                        <div>{appLanguage === 'hi' ? dp.users.su_name_hi || dp.users.su_name : dp.users.su_name}</div>
                                    </Card.Header>
                                    <Card.Body className='d-flex align-items-center justify-content-center' dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? dp.dp_details_hi || dp.dp_details : dp.dp_details}}></Card.Body>
                                </Card>
                            </Col>
                        ))}
                        </Row>
                    </Card.Body>
                </Card>
            )}
            </Card.Body>
        </Card>
    );
}
export default DepartmentProjects;